import React from 'react'
import { Tooltip } from '@theneatcompany/nui'
import Image from 'next/image'

import { useSignUp } from '@/components/Providers/SignUpProvider'
import Form from '@/components/forms/Form'
import { Link } from '@/components/common'
import savingsImg from '@/assets/buy-flow/savings.png'

import styles from './SignUp.module.scss'
import SignUpLayout from './SignUpLayout'
import FormBox from './FormBox'

const Upsell = () => {
  const { saveStepUpsell, plan } = useSignUp()

  const saveData = async () => {
    saveStepUpsell(true)
  }

  const handleDecline = () => {
    saveStepUpsell(false)
  }

  const tooltipContent = (
    <div>
      <p>Everything you need with our NeatHome base, plus premium help from our specialized support team.</p>
      <ul>
        <li>1:1 training guided by Neat Experts</li>
        <li>Dedicated support team so you can skip the line</li>
        <li>Early access to new features</li>
        <li>Exclusive offers</li>
      </ul>
    </div>
  )

  return (
    <SignUpLayout alignCenter split={false}>
      <FormBox shouldCalculateMargin={false}>
        <div className="text-center">

          <Image alt="" className={styles.treasure} src={savingsImg} />
          <h1 className={styles.headline}>
            Commit now<br />
            for a sweet deal!
          </h1>
          <p>If you skip the trial and buy a NeatHome yearly plan now, we'll give you <br />
            <span className={styles.upsellBlueText}>one free year of VIP Service</span>.
          </p>

          <Tooltip
            content={tooltipContent}
            popoverClassName={styles.upsellPopover}
          >
            <div>
              <h3>
                <span className={styles.sweetPackage}>NeatHome + VIP Service</span>
                <span className={styles.sweetWhatis}>What is this plan?</span>
              </h3>
              <div className={`${styles.sweetPriceCol} ${styles.sweetStrike}`}>$129/yr</div>
              <div className={`${styles.sweetPriceCol} ${styles.sweetGreen}`}>$79/yr</div>
            </div>
          </Tooltip>

          <div className={styles.smallPrint}>Neat offers a 30-day money-back guarantee.</div>

          <Form onSubmit={saveData}>
            <Form.Action
              className={styles.submit}
              data-testid="vip-upsell-yes-CTA"
              messageId="pages.signUp.form.upsell.getVip"
              size="large"
              type="submit"
            />
          </Form>

          <Link data-testid="vip-upsell-no-CTA" onClick={handleDecline} to="#">No, continue with {plan.name}</Link>
        </div>
      </FormBox>
    </SignUpLayout>
  )
}

export default Upsell
